import DataGridRowWrapper from 'components/DataGrid/components/DataGridRowWrapper';
import WithHierarchy from 'components/WithHierarchy';
import GridText from 'components/text/GridText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ExpandableRow: FunctionComponent<Props> = ({
    hasChildren = false,
    indent = 0,
    index,
    isLast = [],
    isOpen = false,
    lastActivity = '',
    lastEdited = '',
    name = '',
    onClick,
    parentId,
    rowId,
    rows = [],
    style,
    testId = TEST_ID
}) => {
    if (rows.length === 0) {
        return null;
    }

    return (
        <DataGridRowWrapper style={style} testId={testId}>
            <WithHierarchy
                hasChildren={hasChildren}
                indent={indent}
                index={index}
                isLast={isLast}
                isOpen={isOpen}
                onClick={onClick}
                parentId={parentId}
                rowId={rowId}
                rows={rows}>
                <GridText text={name} />
            </WithHierarchy>

            <GridText className={styles.lastEdited} text={lastEdited} />

            <GridText className={styles.lastActivity} text={lastActivity} />
        </DataGridRowWrapper>
    );
};

export default ExpandableRow;
